import { render, staticRenderFns } from "./ConfirmationDutyNote.vue?vue&type=template&id=94e27788&"
import script from "./ConfirmationDutyNote.vue?vue&type=script&lang=js&"
export * from "./ConfirmationDutyNote.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports